module.exports = __webpack_public_path__ + "assets/7a1eb40afdabb0b8a677c6cc812ee7c4.png";